// Table showing an overview of all user suggestions for the database

import React, { useState, useEffect } from "react";
import axios from "axios";
import {Button,Table} from 'semantic-ui-react';
import '../../css/tableview.css';
import SuggestionModal from "./SuggestionModal";

const TableRow = ({ entry, onDelete, onEdit, onAdd, editMode }) => {
  const hostingServer = `https://sugardb.cs.uct.ac.za/`;

  const [open, setOpen] = useState(false);

  return (
    <tr className="table-row">
      <td>
        <Button onClick={() => setOpen(true)}>View</Button>
        <SuggestionModal open={open} onClose={() => setOpen(false)} entry={entry} onDelete={onDelete} onEdit={onEdit} onAdd={onAdd} editMode={editMode}/>
      </td>
      <td>{entry.Name}</td>
      <td>{entry.Email}</td>
      <td>{entry.Serotype}</td>
      <td>{entry.Antigen_structure}</td>
      <td>{entry.Carbuilder_structure_format}</td>
      <td>{entry.NMR}</td>
      <td>{entry.Species_where_found}</td>
      <td>{entry.Antigen_type}</td>
      <td>{entry.Molecular_type}</td>
      <td>{entry.DOI}</td>
      <td>{entry.References}</td>
      <td>{entry.Branched === 1 ? 'yes' : entry.Branched === 0 ? 'no' : ''}</td>
      <td>{entry.Repeat_unit_size === '0' ? "Unknown" : entry.Repeat_unit_size}</td>
      <td>{entry.EntryDate}</td>
    </tr>
  );
};

export default function SuggestionTable() {
  const hostingServer = `https://sugardb.cs.uct.ac.za/`;
  const [selectData, setSelectData] = useState([]);

  // Fetch user suggestions from the backend
  const axiosFetchData = async () => {
    try {
      const response = await axios.get(`${hostingServer}api/userSuggestions`);
      setSelectData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // delete suggestion from the database
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${hostingServer}api/userSuggestions/${id}`);
      axiosFetchData(); // Refresh the table data
    } catch (error) {
      console.log('Error deleting suggestion', error);
    }
  };

  // move suggestion to the main database, delete from user suggestions
  const handleAdd = async (id) => {
    console.log('Adding suggestion to database: ' + id);
    try {
        await axios.post(`${hostingServer}api/userSuggestions/${id}`);
        axiosFetchData(); // Refresh the table data
        alert('Suggestion added successfully.');
    } catch (error) {
        if (error.response) {
            if (error.response.status === 404) {
                alert('Suggestion not found.');
            } else if (error.response.status === 500) {
                alert('Internal Server Error. Please try again later.');
            } else {
              alert(`Error: ${error.response.data}`);
            }
        } else {
          alert('Network error. Please check your connection.');
        }
        console.error('Error adding suggestion:', error);
    }
};

  // edit suggestion in the database by posting the edited entry
  const handleEdit = async (editedEntry) => {
      console.log('Editing suggestion for: ' + editedEntry._id);

      try {
        // put request to edit the entry
        await axios.put(`${hostingServer}api/userSuggestions/${editedEntry._id}`, editedEntry);
        axiosFetchData(); // Refresh the table data
        alert('Suggestion edited successfully.');
      } catch (error) {
        if (error.response) {
            if (error.response.status === 404) {
                alert('Suggestion not found.');
            } else if (error.response.status === 500) {
                alert('Internal Server Error. Please try again later.');
            } else {
                alert(`Error: ${error.response.data}`);
            }
        } else {
            alert('Network error. Please check your connection.');
        }
        console.error('Error updating suggestion:', error);
    }
  };

  useEffect(() => {
    axiosFetchData();
  }, []);

  return (
    <div style={{ overflowY: "auto", height: '80vh' }}>
      <Table celled style={{ borderRadius: "2vh" }}>
        <Table.Header style={{ position: "sticky", top: "0", zIndex: "1" }}>
          <Table.Row>
            <Table.HeaderCell><h3></h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Name</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Email</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Serotype</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Antigen Structure</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Carbuilder format</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>NMR</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Species where found</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Antigen type</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Molecular type</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>DOI</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>References</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Branched</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Repeat unit size</h3></Table.HeaderCell>
            <Table.HeaderCell><h3>Entry Date</h3></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {selectData.map((entry, index) => (
            <TableRow entry={entry} key={index} onDelete={handleDelete} onEdit={handleEdit} onAdd={handleAdd} />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}
